(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-goal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('joy-shipping-progress')) {
    class JoyShippingProgress extends HTMLElement {
      static choice = null;

      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.sequence = 0;
        this.select = this.querySelector('[data-country-select]');
        this.message = this.querySelector('[data-message]');
        this.track = this.querySelector('[data-track]');
        this.fill = this.querySelector('[data-fill]');
        this.amounts = this.querySelector('[data-amounts]');
        this.formatMoney = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
        this.total = Number(this.dataset.total) || 0;
        this.count = Number(this.dataset.count) || 0;
        this.currency = this.dataset.currency;
        this.requiresShipping = this.dataset.requiresShipping !== 'false';
        this.market = this.dataset.market;
        this.country = this.dataset.country;
        let saved = JoyShippingProgress.choice;
        if (!saved) {
          try { saved = JSON.parse(sessionStorage.getItem('joy-shipping-country-v1') || 'null'); } catch (_) { /* Storage is optional. */ }
        }
        if (saved && saved.market === this.market && this.hasCountry(saved.country)) this.country = saved.country;
        this.select.value = this.country;
        if (typeof Intl.DisplayNames === 'function') {
          const names = new Intl.DisplayNames([this.dataset.locale || 'de'], {type: 'region'});
          for (const option of this.select.options) if (option.value !== 'OTHER') option.textContent = names.of(option.value);
        }
        this.querySelector('[data-country-control]').hidden = false;
        this.onSelection = () => this.chooseCountry(this.select.value);
        this.onCountry = (event) => {
          if (event.detail?.market === this.market && this.hasCountry(event.detail.country)) {
            this.country = event.detail.country;
            this.select.value = this.country;
            this.renderProgress();
          }
        };
        this.onCart = (event) => this.acceptCart(event.detail?.cart);
        this.onAdded = () => this.refreshCart();
        this.onPageShow = (event) => { if (event.persisted) this.refreshCart(); };
        this.onAddressCountry = (event) => {
          if (!event.target.matches?.('select[name="address[country]"]')) return;
          const selected = event.target.selectedOptions[0];
          const value = selected?.value;
          const code = selected?.dataset.code;
          const match = Array.from(this.select.options).find((option) => option.value === code || option.dataset.english === value || option.textContent === value);
          this.chooseCountry(match ? match.value : 'OTHER');
        };
        this.select.addEventListener('change', this.onSelection);
        document.addEventListener('joy:shipping-country', this.onCountry);
        document.addEventListener('cart:updated', this.onCart);
        document.addEventListener('product-ajax:added', this.onAdded);
        document.addEventListener('change', this.onAddressCountry);
        window.addEventListener('pageshow', this.onPageShow);
        this.renderProgress();
      }

      disconnectedCallback() {
        this.sequence += 1;
        this.select?.removeEventListener('change', this.onSelection);
        document.removeEventListener('joy:shipping-country', this.onCountry);
        document.removeEventListener('cart:updated', this.onCart);
        document.removeEventListener('product-ajax:added', this.onAdded);
        document.removeEventListener('change', this.onAddressCountry);
        window.removeEventListener('pageshow', this.onPageShow);
        this.ready = false;
      }

      hasCountry(code) { return Array.from(this.select.options).some((option) => option.value === code); }

      chooseCountry(code) {
        if (!this.hasCountry(code)) return;
        const choice = { country: code, market: this.market };
        JoyShippingProgress.choice = choice;
        try { sessionStorage.setItem('joy-shipping-country-v1', JSON.stringify(choice)); } catch (_) { /* No persistence required. */ }
        document.dispatchEvent(new CustomEvent('joy:shipping-country', { detail: choice }));
      }

      acceptCart(cart) {
        if (!cart || !Number.isFinite(Number(cart.total_price)) || !Number.isFinite(Number(cart.item_count))) {
          this.refreshCart();
          return;
        }
        this.sequence += 1;
        this.total = Math.max(0, Number(cart.total_price));
        this.count = Number(cart.item_count);
        this.currency = cart.currency || this.currency;
        if (typeof cart.requires_shipping === 'boolean') this.requiresShipping = cart.requires_shipping;
        else if (Array.isArray(cart.items)) this.requiresShipping = cart.items.some((item) => item.requires_shipping !== false);
        this.dataset.total = String(this.total);
        this.dataset.count = String(this.count);
        this.dataset.currency = this.currency;
        this.dataset.requiresShipping = String(this.requiresShipping);
        this.renderProgress();
      }

      async refreshCart() {
        const request = ++this.sequence;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Cart unavailable');
          const cart = await response.json();
          if (this.isConnected && request === this.sequence) {
            if (Number.isFinite(Number(cart.total_price)) && Number.isFinite(Number(cart.item_count))) this.acceptCart(cart);
            else this.hidden = true;
          }
        } catch (_) {
          if (this.isConnected && request === this.sequence) this.hidden = true;
        }
      }

      renderProgress() {
        this.hidden = this.count <= 0 || !this.requiresShipping;
        const goal = this.country === 'DE' ? Number(this.dataset.deGoal) : this.country === 'OTHER' ? 0 : Number(this.dataset.euGoal);
        const calculable = goal > 0 && this.currency === 'EUR';
        this.track.hidden = !calculable;
        this.amounts.hidden = !calculable;
        this.dataset.country = this.country;
        const countryName = this.select.selectedOptions[0]?.textContent || this.dataset.other;
        this.querySelector('[data-country-label]').textContent = `${this.dataset.calculation}${countryName}.`;
        if (!calculable) {
          this.message.textContent = this.country === 'OTHER'
            ? this.dataset.unsupported
            : this.dataset.summary;
          return;
        }
        const remaining = Math.max(0, goal - this.total);
        const percent = Math.min(100, Math.max(0, this.total / goal * 100));
        this.fill.style.width = `${percent}%`;
        this.track.setAttribute('aria-valuenow', String(Math.round(percent * 100) / 100));
        this.track.setAttribute('aria-valuetext', remaining > 0 ? `${this.dataset.prefix}${this.formatMoney(remaining)}${this.dataset.suffix}` : this.dataset.achieved);
        this.querySelector('[data-total-label]').textContent = this.formatMoney(this.total);
        this.querySelector('[data-goal-label]').textContent = this.formatMoney(goal);
        this.message.replaceChildren();
        const emphasis = document.createElement('strong');
        if (remaining > 0) {
          emphasis.textContent = this.formatMoney(remaining);
          this.message.append(this.dataset.prefix, emphasis, this.dataset.suffix);
        } else {
          emphasis.textContent = this.dataset.free;
          this.message.append(emphasis);
        }
      }
    }
    customElements.define('joy-shipping-progress', JoyShippingProgress);
  }
  } catch(e) { console.error(e); }
})();

})();
